export const CHECKIN_ACTION_NAMES = {
  EVENT: "event",
  SEND_MAIL: "sendmail",
  UPLOAD_FILE: "uploadfile",
  CREATE_CALENDAR_ENTRY: "createCalendarEntry"
};
